export class Address {

    Name: string;
    Address1: string;
    Address2: string;
    Postal_Code: string;
    City: string;
    Latitude: number;
    Longitude: number;
    Phone: string;
}
